
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.877 2A5.302 5.302 0 004.56 7.318a5.303 5.303 0 005.318 5.318 5.302 5.302 0 005.318-5.318A5.301 5.301 0 009.877 2zm0 1.5a3.801 3.801 0 013.818 3.818 3.802 3.802 0 01-3.818 3.818A3.803 3.803 0 016.06 7.318 3.802 3.802 0 019.877 3.5zm0 10.956c-5.03 0-7.877.955-7.877 3.66 0 2.707 2.86 3.68 7.877 3.68l.644-.006c4.627-.081 7.233-1.068 7.233-3.654 0-2.648-2.736-3.637-7.552-3.678l-.325-.002zm0 1.5c4.202 0 6.377.74 6.377 2.18 0 1.431-2.17 2.16-6.377 2.16-4.201 0-6.377-.74-6.377-2.18 0-1.394 2.054-2.12 6.04-2.158l.337-.002zm9.327-8.037a.75.75 0 01.743.648l.007.102v1.255h1.296a.75.75 0 01.102 1.493l-.102.007h-1.296v1.255a.75.75 0 01-1.493.102l-.007-.102v-1.255H17.16a.75.75 0 01-.102-1.493l.102-.007h1.294V8.669a.75.75 0 01.75-.75z","fill":"#FCFDFF"}})])
          )
        }
      }
    